import React, {Fragment} from 'react';
import { t } from '../i18n';
import {Query} from "react-apollo";

import queries from "../queries";

class ScreenTypeSelector extends React.Component {
  state = {};

  render() {
    return (
      <Query query={queries.screenTypes.list}>
        {({ loading, error, data }) => {
          if (loading) return t('ui.common.loading');
          if (error) return `Error! ${error.message}`;

          const {screenTypes} = data;
          const screenType = !!this.state.screenType ? this.state.screenType : screenTypes[0];

          // The <select> is handed to children so it can be placed inside the
          // editor's center header (next to CANVAS/SPLIT/PREVIEW) rather than
          // occupying a strip above the whole editor.
          const screenTypeSelect = (
            <select className="tsk-screentype-select" value={screenType.id} onChange={(e) => {
              const screenTypeId = e.target.value;
              const newScreenType =  screenTypes.filter((st) => st.id === screenTypeId)[0];
              this.setState({screenType: newScreenType});
            }}>
              {screenTypes.map((screenType) => (
                <option key={screenType.id} value={screenType.id}>{screenType.name}</option>
              ))}
            </select>
          );

          return (
            <Fragment>
              {this.props.children(screenType, screenTypeSelect)}
            </Fragment>
          );
        }}
      </Query>
    )
  }
}

export default ScreenTypeSelector;
